import React, { useState } from 'react';
import { useParams } from 'react-router';
import { Box, Typography, Tabs, Tab } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useFetchEmailsQuery } from '../../store/email/EmailApi';
import EmailList from './EmailList';
import EmailDetail from './EmailDetail';

const TABS = [
  { label: 'Posteingang', status: 'open,in_progress' },
  { label: 'Erledigt',    status: 'answered,done'    },
  { label: 'Gesendet',    status: 'outgoing'         },
  { label: 'Alle',        status: ''                 },
];

export default function Email() {
  const { year }    = useParams();
  const isMobile    = useMediaQuery('(max-width:680px)');
  const [tabIndex,    setTabIndex]    = useState(0);
  const [selectedId, setSelectedId] = useState(null);

  const status = TABS[tabIndex].status;
  const { data: emails, isLoading } = useFetchEmailsQuery({ year, status });

  const showList   = !isMobile || selectedId === null;
  const showDetail = !isMobile || selectedId !== null;

  const handleTabChange = (_, newIndex) => {
    setTabIndex(newIndex);
    setSelectedId(null);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 180px)' }}>

      <Tabs
        value={tabIndex}
        onChange={handleTabChange}
        sx={{ borderBottom: 1, borderColor: 'divider', flexShrink: 0 }}
      >
        {TABS.map((tab, i) => (
          <Tab key={i} label={tab.label} />
        ))}
      </Tabs>

      <Box sx={{ display: 'flex', gap: 2, flexGrow: 1, overflow: 'hidden' }}>

        {!isLoading && showList && (
          <Box sx={{
            width: { xs: '100%', sm: '380px' },
            flexShrink: 0,
            overflowY: 'auto',
            borderRight: { sm: '1px solid' },
            borderColor: { sm: 'divider' },
          }}>
            <EmailList
              emails={emails ?? []}
              selectedId={selectedId}
              onSelect={setSelectedId}
            />
          </Box>
        )}

        {showDetail && (
          <Box sx={{ flexGrow: 1, overflowY: 'auto' }}>
            {selectedId ? (
              <EmailDetail
                year={year}
                emailId={selectedId}
                onBack={() => setSelectedId(null)}
              />
            ) : (
              !isLoading && (
                <Box sx={{ p: 4, color: 'text.secondary' }}>
                  <Typography>E-Mail auswaehlen</Typography>
                </Box>
              )
            )}
          </Box>
        )}

      </Box>
    </Box>
  );
}
